import { render, staticRenderFns } from "./ProfileImageSection.vue?vue&type=template&id=4964e694&scoped=true"
import script from "./ProfileImageSection.vue?vue&type=script&lang=js"
export * from "./ProfileImageSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4964e694",
  null
  
)

export default component.exports